var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubble",class:{ 'hidden' : _vm.hidden, 'animate' : !_vm.hidden }},[_c('img',{staticClass:"background",attrs:{"src":require("@/assets/bubble-background.svg")}}),_c('img',{staticClass:"foreground",attrs:{"src":require("@/assets/bubble-foreground.svg")}}),_c('div',{staticClass:"center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }